import { SET_DOES_TOTAL_EXCEED_CART_MAXIMUM } from 'bento-ordering/cart/constants/actionTypes';
import { getCartItem } from 'bento-ordering/cart/utils/getCartItem';
import get from 'lodash/get';

/**
 * action to determine if the cart items total will exceed maximum. If
 * the max amount is 0 dollars that means maximum is not being enforced.
 * MenuItemDetail: subtotal + productpreviewtotal > max?
 * EditCartItem: (subtotal - selectedItemTotal) + productpreview > max?
 */
export const getIsCartTotalExceedMaximum = editItemId => (
  dispatch,
  getState
) => {
  const state = getState();
  const orderMaximum = get(state.cart, 'max_order_amount', 0);
  const max = parseFloat(orderMaximum);
  // if max amount is < 1 then dispatch exceed cart max = false
  if (max < 1) {
    return dispatch({
      type: SET_DOES_TOTAL_EXCEED_CART_MAXIMUM,
      payload: false
    });
  }

  let cartTotalBeforeTax = state.cart.subtotal;
  if (editItemId) {
    const cartItems = state.cart.items;
    const cartItem = getCartItem(editItemId, cartItems);
    cartTotalBeforeTax -= parseFloat(cartItem.total);
  }

  const productPreview = state.productPreview.final_price;
  const isExceed =
    parseFloat(productPreview) + parseFloat(cartTotalBeforeTax) > max;
  dispatch({ type: SET_DOES_TOTAL_EXCEED_CART_MAXIMUM, payload: isExceed });
};
